import whitelogo from "../assets/whiteintel-white-logo-new.png";

export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen bg-[#070c16] text-white relative overflow-hidden">
      {/* Dot-wave background — dots arranged along sine curves */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='40' viewBox='0 0 120 40'><g fill='%2394a3b8' fill-opacity='0.45'><circle cx='0' cy='20' r='1.2'/><circle cx='10' cy='27' r='1.2'/><circle cx='20' cy='32.1' r='1.2'/><circle cx='30' cy='34' r='1.2'/><circle cx='40' cy='32.1' r='1.2'/><circle cx='50' cy='27' r='1.2'/><circle cx='60' cy='20' r='1.2'/><circle cx='70' cy='13' r='1.2'/><circle cx='80' cy='7.9' r='1.2'/><circle cx='90' cy='6' r='1.2'/><circle cx='100' cy='7.9' r='1.2'/><circle cx='110' cy='13' r='1.2'/></g></svg>\")",
          backgroundSize: "120px 40px",
          maskImage:
            "radial-gradient(ellipse 80% 70% at 50% 50%, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 80% 70% at 50% 50%, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
        }}
      />

      {/* Secondary dot-wave layer — offset, cyan-tinted */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='40' viewBox='0 0 120 40'><g fill='%2338bdf8' fill-opacity='0.30'><circle cx='0' cy='20' r='1'/><circle cx='10' cy='27' r='1'/><circle cx='20' cy='32.1' r='1'/><circle cx='30' cy='34' r='1'/><circle cx='40' cy='32.1' r='1'/><circle cx='50' cy='27' r='1'/><circle cx='60' cy='20' r='1'/><circle cx='70' cy='13' r='1'/><circle cx='80' cy='7.9' r='1'/><circle cx='90' cy='6' r='1'/><circle cx='100' cy='7.9' r='1'/><circle cx='110' cy='13' r='1'/></g></svg>\")",
          backgroundSize: "120px 40px",
          backgroundPosition: "60px 20px",
          maskImage:
            "radial-gradient(ellipse 80% 70% at 50% 50%, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 80% 70% at 50% 50%, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
        }}
      />

      {/* Soft cyan glow from top */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-48 left-1/2 -translate-x-1/2 h-[640px] w-[1000px] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(closest-side, rgba(56,189,248,0.16), rgba(56,189,248,0) 70%)",
        }}
      />

      {/* Iceberg watermark — pure CSS */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none"
        style={{ opacity: 0.055 }}
      >
        <div className="relative" style={{ width: 560, height: 620 }}>
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: 40,
              width: 230,
              height: 190,
              background:
                "linear-gradient(180deg, #ffffff 0%, #d4ecff 55%, #9dc8ee 100%)",
              clipPath:
                "polygon(50% 0%, 70% 22%, 100% 60%, 92% 100%, 8% 100%, 0% 60%, 30% 22%)",
              filter: "drop-shadow(0 0 20px rgba(125,211,252,0.4))",
            }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: 235,
              width: 540,
              height: 1,
              background:
                "linear-gradient(90deg, transparent, rgba(125,211,252,0.7) 50%, transparent)",
            }}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2"
            style={{
              top: 240,
              width: 470,
              height: 370,
              background:
                "linear-gradient(180deg, #c3def4 0%, #6ba8df 30%, #2f547e 70%, #0f1f33 100%)",
              clipPath:
                "polygon(8% 0%, 92% 0%, 80% 30%, 78% 55%, 68% 100%, 32% 100%, 22% 55%, 20% 30%)",
            }}
          />
          <div
            className="absolute"
            style={{
              top: 170,
              left: 360,
              width: 70,
              height: 70,
              background:
                "linear-gradient(180deg, #ffffff 0%, #cce4ff 100%)",
              clipPath: "polygon(50% 0%, 100% 80%, 0% 80%)",
            }}
          />
        </div>
      </div>

      {/* Foreground content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-10">
        {/* Brand mark */}
        <div className="mb-7 flex flex-col items-center">
          <img
            src={whitelogo}
            alt="WhiteIntel"
            className="h-12 w-12 rounded-md"
          />
          <div
            className="mt-3 text-[13px] tracking-[0.22em] text-neutral-300 uppercase"
            style={{ fontFamily: '"Saira", ui-sans-serif, system-ui, sans-serif' }}
          >
            WhiteIntel
          </div>
          <div className="text-[11px] text-neutral-500 mt-0.5 tracking-wide">
            Dark Web Intelligence Platform
          </div>
        </div>

        {children}

        {/* Footer links */}
        <div className="mt-8 flex flex-col items-center gap-2 text-[11.5px] text-neutral-500">
          <div className="flex items-center justify-center gap-3">
            <a href="https://whiteintel.io" className="hover:text-neutral-300" target="_blank" rel="noreferrer">Home</a>
            <span className="text-neutral-700">·</span>
            <a href="https://knowledge.whiteintel.io/" className="hover:text-neutral-300" target="_blank" rel="noreferrer">Knowledge Center</a>
            <span className="text-neutral-700">·</span>
            <a href="https://whiteintel.io/terms" className="hover:text-neutral-300" target="_blank" rel="noreferrer">Terms</a>
            <span className="text-neutral-700">·</span>
            <a href="https://whiteintel.io/privacy" className="hover:text-neutral-300" target="_blank" rel="noreferrer">Privacy</a>
          </div>
          <div className="text-[11px] text-neutral-600">v4.0.5 © 2026 Whiteintel</div>
        </div>
      </div>
    </div>
  );
}
